import { Box, FormControl, FormLabel, Select } from '@chakra-ui/react';
import { useClientRefereralTypes } from 'hooks/useApiQueries';
import { useGetReferalId } from 'hooks/useGetReferalId';
import { RegisterData } from 'providers/useUserContext';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

/**
 * Sites d'Annecy (Dynamo, Riise, Punch) : question retirée à la demande de Charbel (22/10/2026), les clients ne
 * savaient pas quoi répondre. Elle reste affichée (et verrouillée) dans le parcours de parrainage, qui la préremplit.
 */
const SITES_WITHOUT_REFERRAL_QUESTION = ['5748709', '5748656', '5757102'];

const currentSiteId = (): string =>
  typeof mondayMindbody !== 'undefined' && mondayMindbody?.siteId ? String(mondayMindbody.siteId) : '';

export function ReferalTypeSelect() {
  const ReferralClientId = useGetReferalId();
  if (!ReferralClientId && SITES_WITHOUT_REFERRAL_QUESTION.includes(currentSiteId())) return null;
  return <ReferalTypeSelectField />;
}

function ReferalTypeSelectField() {
  const ReferralClientId = useGetReferalId();
  const {
    register,
    getValues,
    formState: { errors },
  } = useFormContext<RegisterData>();
  const { t } = useTranslation();
  const { data: referalTypes, isLoading } = useClientRefereralTypes();
  const getTranslation = (referralType: string) => {
    const key = `referred_by.${referralType}`;
    const value = t(key);
    return value === key ? referralType : value;
  };

  const options = (referalTypes || [])
    .map((value) => ({ value, label: getTranslation(value) }))
    .sort((a, b) => a.label.localeCompare(b.label));

  return (
    <FormControl isInvalid={!!errors.ReferredBy}>
      <Box maxW={400}>
        <FormLabel textTransform={'uppercase'}>Comment avez-vous entendu parler de nous ?</FormLabel>
        <Select
          placeholder={isLoading ? 'Chargement...' : 'Sélectionner une option'}
          {...register('ReferredBy', {})}
          isDisabled={isLoading || (!!ReferralClientId && !!getValues('ReferredBy'))}
        >
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      </Box>
    </FormControl>
  );
}
